<!-- 通知公告详情 -->
<template>
  <div class="announcementd">
    <div class="title">
      <div class="title-top">
        {{ dataList.title || "未知" }}
      </div>
      <div class="title-info">
        <span class="writer">作者：{{ dataList.creater || "未知" }}</span>
        <span class="time"
          >发布时间：{{ dataList.create_time | dateFormat }}</span
        >
        <span class="click">点击数：{{ dataList.click || "未知" }}</span>
      </div>
    </div>
    <div class="ment-main" v-html="dataList.content"></div>
  </div>
</template>

<script>
import encrypt from "../utils/encrypt";
import { getStudentNoticeDetail } from "@/api/common";
import { getToken, getUid } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    openNew(val) {
      this.$router.push({
        path: "/announcementd",
        query: {
          id: val,
        },
      });
    },
    fetchData(ids) {
      let token = getToken();
      let uid = getUid();
      let data = {
        uid: uid,
        id: this.$route.query.id,
      };
      data = encrypt.Encrypt(JSON.stringify(data), token);
      token = encrypt.Encrypt(JSON.stringify(token), "");
      let params = {
        data: data,
        token: token,
      };
      getStudentNoticeDetail(params).then((response) => {
        this.dataList = response.data;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.announcementd {
  .title {
    padding-top: 38px;
    padding-left: 37px;
    padding-right: 60px;
    font-size: 24px;
    color: #00468e;
    height: 125px;
    border-bottom: 1px solid #ebebeb;
    .title-top {
      font-size: 23px;
      text-align: center;
      color: #035bb2;
      margin-bottom: 20px;
      font-weight: 700;
    }
    .title-info {
      font-size: 14px;
      color: #989898;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 85px;
      span {
        margin-right: 20px;
      }
    }
  }
  .fl {
    float: left;
  }
  .fr {
    float: right;
  }
  .ment-main {
    height: calc(100% - 75px);
    padding-top: 37px;
    padding-left: 37px;
    padding-right: 60px;
    ul {
      width: 100%;
      height: 100%;
      padding-bottom: 30px;
      border-bottom: 1px solid #d8d8d8;
      li {
        font-size: 17px;
        color: #bfbfbf;
        height: 40px;
        cursor: pointer;
        i {
          background-image: url("./../assets/201.png");
          background-repeat: no-repeat;
          display: inline-block;
          width: 12px;
          height: 16px;
          margin-right: 15px;
        }
      }
    }
  }
}
</style>
